/**
 * Ids shared between the recruitment surfaces, so a caller that wants to land
 * somewhere specific and the page that renders it cannot drift apart.
 *
 * Both are values that already exist in the app; naming them here is what lets
 * ClientV2's 招募 view point at them without importing a view into a component
 * or vice versa.
 */

/**
 * The MDRT 活動量計算 entry inside the 行業前景 contents dialog
 * (RecruitmentContentsDialog's tools section). Passed back as the dialog's
 * `focusItem` so the drawer's own tile opens the calculator rather than the
 * library's front page.
 */
export const RECRUITMENT_MDRT_ITEM_ID = 'mdrt-calculator';

/**
 * The 建團隊收入模擬器 entry beside it, landed on the same way from the
 * drawer's 收入模擬 tile.
 */
export const RECRUITMENT_INCOME_SIM_ITEM_ID = 'income-simulator';

/**
 * The 招聘 & 成長 row on the 懶人包 page (HotTopicContentSlidesNew's
 * `categories`). It is the LAST category there, so the page has to scroll to
 * reach it — which is why a caller sends this rather than trusting the adviser
 * to find it.
 */
export const RECRUITMENT_HOT_TOPIC_CATEGORY_ID = 'recruit-and-growth';
